interface IProps<T> {
  videos: T[]
  adVideos: T[]
  positions: number[]
}

/**
 * This function will put ad videos to specific position inside feed videos
 */
export function putAdsToPositionInFeed<T>(props: IProps<T>): T[] {
  const { videos, adVideos, positions } = props
  if (positions.length === 0 || adVideos.length === 0) {
    return videos
  }
  const positionSet = new Set(positions)
  const videosClone: T[] = [...videos]
  const adVideosClone: T[] = [...adVideos]
  const stitchedVideos: T[] = []
  while (videosClone.length > 0) {
    const index = stitchedVideos.length
    if (positionSet.has(index) && adVideosClone.length > 0) {
      stitchedVideos.push(adVideosClone.shift()!)
    } else {
      stitchedVideos.push(videosClone.shift()!)
    }
  }
  return stitchedVideos
}
